<template>
  <div>
    <div
      class="sidenav"
      :class="{visible: opened, hidden: !opened, login: login}"
    >
      <div class="flex">
        <img
          class="company-logo"
          :src="api_uri +'/static-files/BootLogos/new_soda_white.png'"
        >
        <div
          @click.stop="toggleMenu"
          class="close-button"
        ><i class="far fa-times"></i></div>
      </div>
      <ul>
        <aside class="menu">
          <ul class="user-indicator">
            <span class="user-name">{{ getUserName() }}</span>
            <a @click.stop="logout()"> <i class="far fa-power-off"></i> Déconnexion</a>
          </ul>
          <ul>
            <p class="menu-label"><br><br>MONITORING</p>
            <ul class="menu-list">
              <li>
                <ul>
                  <li>
                    <router-link :to="{name: 'dashboard'}"> <i class="icon fal fa-tachometer"></i> Tableau de Bord</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'sales'}"> <i class="icon fal fa-usd-circle"></i> Ventes</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <p class="menu-label">ADMINISTRATION</p>
            <ul class="menu-list">
              <li>
                <ul>
                  <li>
                    <router-link :to="{name: 'weezys'}"> <i class=" icon fal fa-robot"></i> {{ getIsAdmin() ? "Weezys" : "Weezy" }}</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'challenges'}"> <i class="icon fal fa-swords"></i> Défis</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'users'}"> <i class="icon fal fa-users"></i> Utilisateurs</router-link>
                  </li>
                  <li v-if="getIsAdmin()">
                    <router-link :to="{name:'config'}"> <i class="icon fal fa-cog"></i> Configuration Weezy/Led Strip </router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <p class="menu-label">PARAMÈTRAGE</p>
            <ul class="menu-list">
              <li>
                <ul>
                  <li v-if="getIsAdmin()">
                    <router-link :to="{name: 'campaigns'}"> <i class="icon fal fa-suitcase"></i> Campagnes</router-link>
                  </li>
                  <li v-else>
                    <router-link :to="{name: 'campaigns'}"> <i class="icon fal fa-suitcase"></i>Mes Campagnes</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'goals'}"> <i class="icon fal fa-calendar-alt"></i> Objectifs Quotidiens</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'themes'}"> <i class="icon fal fa-palette"></i> Thèmes</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'customizations'}"> <i class="icon fal fa-brush"></i> Personalisation Weezy</router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <p class="menu-label">SOCIAL</p>
            <ul class="menu-list">
              <li>
                <ul>
                  <li>
                    <router-link :to="{name: 'gamescores'}"> <i class="icon fal fa-gamepad"></i> Mini-Jeu Weezy</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'weezypictures'}"> <i class="icon fal fa-camera"></i> Photos Weezy</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </ul>
        </aside>
      </ul>
    </div>
    <div
      class="open-menu-button"
      :class="{visible: !opened, hidden: opened,login: login}"
      @click.stop="toggleMenu"
    >
      <i class="fal fa-bars"></i> Menu </div>
  </div>
</template>

<script>
export default {
  name: "navigation-bar",
  data: () => {
    return {
      api_uri: process.env.VUE_APP_API_URI,
      opened: false,
      login: false
    };
  },
  created() {
    this.getIsAdmin();
  },

  watch: {
    opened(newVal) {
      if (newVal) {
        document.querySelector("body").style.overflow = "hidden";
      } else {
        document.querySelector("body").style.overflow = "auto";
      }
    },
    $route(to, from) {
      this.opened = false;
    }
  },

  methods: {
    toggleMenu() {
      this.opened = !this.opened;
    },

    logout() {
      this.$store.commit("logout");
    },
    getUserName() {
      return this.$store.state.fullname;
    },
    getIsAdmin() {
      return this.$store.state.role == "admin";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* PHONE SIZE */
@media screen and (max-width: 768px) {
  .close-button {
    color: white;
    cursor: pointer;
    margin: auto;
    font-size: 50px;
    float: right;
  }

  .open-menu-button {
    cursor: pointer;
    color: white;
    top: 27px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 10px 6px;
    position: fixed;
    font-size: 18px;
    background-color: rgb(42, 163, 214);
    z-index: 998;
    transition: 0.6s;
  }

  .open-menu-button.hidden {
    transform: translateX(-100%);
  }

  .company-logo {
    width: 180px;
    height: 83px;
  }

  .user-indicator {
    font-size: 0.8em;
    height: 30px;
  }

  /* sidenav style */
  .sidenav {
    height: 100%;
    width: inherit;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgba(0, 0, 0, 0.4) 20px 0px 20px 20px;
  }

  .sidenav.hidden {
    transform: translateX(-100%);
    box-shadow: none;
  }

  /* menubar links */
  .sidenav a {
    padding: 4px 0px 4px 0px;
    font-size: 18px;
  }

  /* MENU SECTION */
  .menu-label {
    font-size: 11px;
  }

  .icon {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .company-logo {
    width: 180px;
    height: 83px;
  }

  .close-button {
    display: none;
  }

  .open-menu-button {
    display: none;
  }

  .user-indicator {
    font-size: 1.3em;
    height: 80px;
  }

  /* sidenav style */
  .sidenav {
    height: 100%;
    width: 210px;
    padding-top: 60px;
    padding-left: 10px;
    padding-right: 10px;
  }

  /* menubar links */
  .sidenav a {
    padding: 4px 0px 4px 0px;
    font-size: 17px;
  }
}

/* sidenav style */
.sidenav {
  height: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgb(42, 163, 214);
  overflow-x: auto;
  transition: 0.5s;
}

.sidenav::-webkit-scrollbar {
  display: none;
}

.sidenav.login {
  display: none;
}

.open-menu-button.login {
  display: none;
}

.menu {
  color: #fff;
}

.menu-label {
  color: #fff;
}

/* menubar links */
.sidenav a {
  text-decoration: none;
  color: #fff;
  display: block;
  transition: 0.5s;
}

/* Change menubar item color when hovered */
.sidenav a:hover {
  color: rgb(42, 163, 214);
  background-color: #fff;
}
</style>